import { isEmpty } from 'lodash';
import { useCallback } from 'react';
import { api } from 'src/assets/static/ApiRoutes';
import useAsync from 'src/hooks/useAsync';
import axiosInstance from 'src/utils/axios';

interface RecallInvoiceRequest {
  invoiceIds?: any[];
}

export interface RecallApiResponseData {
  processedIds: number[];
  unProcessed:
    | {
        id: number;
        errorMessage: string;
      }[]
    | [];
}

const useRecallApi = () => {
  const call = useCallback(async (params?: RecallInvoiceRequest | undefined) => {
    try {
      if (isEmpty(params?.invoiceIds)) {
        throw new Error('invoiceIds empty');
      }
      const res = await axiosInstance.post(api.recallInvoice, params?.invoiceIds || []);
      return res.data as RecallApiResponseData;
    } catch (error) {
      throw new Error(error);
    }
  }, []);

  const { isLoading, execute, status } = useAsync<RecallApiResponseData, RecallInvoiceRequest>(
    call,
    false
  );

  return { recallInvoice: execute, recallCallLoading: isLoading, status };
};
export default useRecallApi;
